import { isEqual, cloneDeep } from 'lodash'
import { getHashId } from '@/components/RedocWrapper/utils/onRedocLoaded'

const showSortOrderUpdateModal = (sectionsData, callback) => {
  // 觸發 Modal 顯示事件
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('showSortOrderUpdateModal', {
      detail: { sectionsData, callback },
    }))
  }
}

export const cleanSection = (section) => {
  const cleanedSection = { ...section }

  delete cleanedSection.treeKey
  delete cleanedSection.treePos
  delete cleanedSection.treeLevel
  delete cleanedSection.treeChildren
  delete cleanedSection.treeTitleNo
  delete cleanedSection.treeTitle
  delete cleanedSection.treeTitleWithRemark
  delete cleanedSection.treeEnTitle
  delete cleanedSection.treeCnTitle
  delete cleanedSection.appliedDocs
  delete cleanedSection.updatedTime
  delete cleanedSection.added
  delete cleanedSection.deleted

  return cleanedSection
}

export const updateSectionsDataSortOrderByTreeData = (treeData, sectionsData, onlyReturnDiff) => {
  const updateSectionsData = []
  treeData.forEach(({
    treeKey, treePos, treeLevel, treeChildren, ...item
  }, idx) => {
    updateSectionsData.push({
      ...item,
      sortOrder: idx,
    })

    if (treeChildren) {
      updateSectionsData.push(...(treeChildren.map(({
        treeKey, treePos, treeLevel, treeChildren, ...c // eslint-disable-line no-shadow
      }, cIdx) => ({
        ...c,
        sortOrder: cIdx,
      }))))
    }
  })
  console.log(1, 'updateSectionsData', updateSectionsData)
  sectionsData.forEach((section) => {
    const findIndex = updateSectionsData.findIndex(({ docId, sectionId }) => docId === section.docId && sectionId === section.sectionId)
    if (findIndex > -1) {
      console.log(section.entitle, section.cntitle, 'before', section.sortOrder, 'after', updateSectionsData[findIndex].sortOrder)
      if (onlyReturnDiff && updateSectionsData[findIndex].sortOrder === section.sortOrder) {
        updateSectionsData.splice(findIndex, 1)
      } else {
        updateSectionsData[findIndex] = { ...section, sortOrder: updateSectionsData[findIndex].sortOrder }
      }
    }
  })
  console.log(2, 'updateSectionsData', updateSectionsData)

  return updateSectionsData
// batchWriteSortOrder()
}

export const transformToNested = ({
  data = [],
  parentSectionId,
  treeLevel = 0,
  posPrefix = '0',
  showNo = true,
  updateSortOrder = false,
}) => {
  if (!data.length) return []
  // if (data[0].docId === 'allwecan.info#multi#PRD' || data[0].docId === 'allwecan.info#multi#IGK') {
  // if (data[0].docId === 'multi#master') {
  //   console.log('transformToNested', {
  //     data, parentSectionId, treeLevel, posPrefix,
  //   })
  // }

  const isDoc = !data[0].docId.includes('master')

  const currentLevel = data
    .filter(section => !section.sectionId.includes('staged-') && section.parentSectionId === parentSectionId)
    .sort((a, b) => a.sortOrder - b.sortOrder)

  const toUpdateSortOrderSectionsData = []

  const result = currentLevel.map((section, index) => {
    // const treeKey = keyPrefix ? `${keyPrefix}-${section.sectionId}` : section.sectionId
    const treePos = `${posPrefix}-${index}`

    let treeNo = 0
    let treeParentNo = ''
    let treeTitleNo = ''
    const increment = isDoc ? 1 : 2 // 母本沒有 Release Version，直接顯示 2. Introdution
    if (showNo) {
      if (parentSectionId) {
        treeParentNo = posPrefix.split('-').slice(-1).map(i => Number(i) + increment).join('.')
        treeNo = index + 1 // 8.x. 的 x 不需要多加 1
        treeTitleNo = `${treeParentNo}.${treeNo}. `
      } else {
        treeNo = index + increment
        treeTitleNo = `${treeNo}. `
      }

      // SectionTree firstLoad 會檢查 sortOrder 是否需要更新
      if (updateSortOrder && index !== section.sortOrder) {
        toUpdateSortOrderSectionsData.push({
          ...cleanSection(section),
          originalSortOrder: section.sortOrder, // 保存更新前的 sortOrder
          sortOrder: index,
        })
      }
    }

    const treeChildren = transformToNested({
      data,
      parentSectionId: section.sectionId,
      treeLevel: treeLevel + 1,
      posPrefix: treePos,
      showNo,
      isDoc,
      updateSortOrder,
    })

    return {
      treeTitleNo,
      treeTitle: `${treeTitleNo}${section.enTitle} ${section.cnTitle}`,
      treeTitleWithRemark: `${treeTitleNo}${section.enTitle} ${section.cnTitle}${section.remark ? ` ${section.remark}` : ''}`,
      treeEnTitle: `${treeTitleNo}${section.enTitle}`,
      treeCnTitle: `${treeTitleNo}${section.cnTitle}`,
      treeKey: `${section.docId}-${section.sectionId}`,
      treePos,
      treeLevel,
      ...(treeChildren.length && { treeChildren }),
      ...section,
    }
  })

  if (updateSortOrder && localStorage.getItem('editor-username').includes('Effie') && toUpdateSortOrderSectionsData.length) {
    console.log('transformToNested toUpdateSortOrderSectionsData', toUpdateSortOrderSectionsData)
    showSortOrderUpdateModal(toUpdateSortOrderSectionsData, (updateSortOrderRes) => {
      console.log('transformToNested update sortOrder res', updateSortOrderRes)
    })
  }

  return result
}

export const findTreeAndKeys = (tree, keyword, path = []) => {
  const matchedKeys = []
  const filteredTree = []

  for (const node of tree) {
    // 记录当前路径
    const newPath = [...path, node.treeKey]

    // 递归检查子节点
    const { nestedTree, keys } = node.treeChildren
      ? findTreeAndKeys(node.treeChildren, keyword, newPath)
      : { nestedTree: [], keys: [] }

    // 如果 title 包含关键字，保留该节点，并添加其 key
    if (node.treeTitleWithRemark.toLowerCase().includes(keyword.toLowerCase()) || nestedTree.length > 0) {
      filteredTree.push({ ...node, treeChildren: nestedTree })
      matchedKeys.push(node.treeKey, ...keys)
    }
  }

  return { nestedTree: filteredTree, keys: [...new Set(matchedKeys)] }
}

export const getContentLinkMatchResult = (content = '') => {
  // [7.4. List of Language Types](wlWA6UHAMr_en)
  // <a href="wlWA6UHAMr_en">7.4. List of Language Types</a>
  const matchResult = []
  const regex = /(?:\[(.+?)\]\(((\w{10})_(en|cn|encn))\)|<a .*?href="((\w{10})_(en|cn|encn))">(.+?)<\/a>)/g

  let matches
  do {
    matches = regex.exec(content)
    if (matches) matchResult.push(matches)
  } while (matches)

  return matchResult.map((match) => {
    // ["7.4. List of Language Types](wlWA6UHAMr_en)", "7.4. List of Language Types", "wlWA6UHAMr_en", "wlWA6UHAMr", "en"]
    let [, toReplaceLinkTitle, toReplaceLinkUrl, sectionId, lang] = match
    // ["<a href=\"1ESrsJs4y7_en\">7.3. List of Currency Types</a>", null, null, null, null, "1ESrsJs4y7_en", "1ESrsJs4y7", "en", "7.3. List of Currency Types"]
    if (!toReplaceLinkTitle) ([,,,,, toReplaceLinkUrl, sectionId, lang, toReplaceLinkTitle] = match)
    // if (sectionId === 'Q6Yt8eqOSo') {
    //   console.log('toReplaceLinkTitle', {
    //     toReplaceLinkUrl, sectionId, lang, toReplaceLinkTitle,
    //   })
    // }

    return {
      sectionId,
      toReplaceLinkTitle,
      toReplaceLinkUrl,
      lang,
    }
  })
}

export const shouldDisplay = (fieldOrSection = {}, docData = {}) => {
  const { platforms = [], clients = [] } = fieldOrSection
  const { platforms: docPlatforms = [], clients: docClients = [], excludedPlatforms: docExcludedPlatforms = [] } = docData
  if (docPlatforms?.length && platforms?.length && platforms.every(platform => !docPlatforms.includes(platform))) return false
  if (docClients?.length && clients?.length && clients.every(client => !docClients.includes(client))) return false
  if (!docPlatforms?.length && platforms?.length && docExcludedPlatforms?.length && platforms.every(platform => docExcludedPlatforms.includes(platform))) return false
  return true
}

export const collectReqResFields = ({
  field, key, section, callBack, parentField, docData,
}) => {
  if (!shouldDisplay(field, docData)) return

  if (field.fields) {
    Object.entries(field.fields).forEach(([childFieldId, childField]) => {
      collectReqResFields({
        field: childField,
        key: `${key}.fields.${childFieldId}`,
        section,
        callBack,
        parentField: field,
        docData,
      })
    })
  }

  if (callBack) {
    callBack({
      field,
      parentField,
      key,
      section,
    })
  }
}

const getSectionAllContents = (section, docData = {}) => {
  const allContents = []
  if (section.content) allContents.push(section.content)
  if (section.restricted) allContents.push(section.restricted.content)
  if (section.tableData) {
    const getTableDataContent = (tableData) => {
      const editorColumnIds = []
      Object.entries(tableData.columns).forEach(([columnId, { element }]) => {
        if (element === 'editor') editorColumnIds.push(columnId)
      })
      if (editorColumnIds.length) {
        tableData.rowData.forEach((row) => {
          editorColumnIds.forEach((columnId) => {
            if (row[columnId]) allContents.push(row[columnId])
          })
        })
      }
    }

    if (section.tableData.platformsOrder) {
      section.tableData.platformsOrder.forEach((platform) => {
        getTableDataContent(section.tableData.platforms[platform])
      })
    } else {
      getTableDataContent(section.tableData)
    }
  }

  if (section.sectionType === 'api') {
    const callBack = ({ field: { content } }) => {
      if (content) allContents.push(content)
    }

    for (const [fieldId, field] of Object.entries(section.response.fields)) {
      collectReqResFields({
        field, key: `response.fields.${fieldId}`, section, callBack, docData,
      })
    }

    for (const [fieldId, field] of Object.entries(section.request.fields)) {
      collectReqResFields({
        field, key: `request.fields.${fieldId}`, section, callBack, docData,
      })
    }
  }

  return allContents
}

export const getLinkSectionIds = (sectionsData = [], docData = {}) => {
  if (!sectionsData.length) return []

  const linkSectionIds = new Set()
  sectionsData.forEach((section) => {
    const sectionContents = getSectionAllContents(section, docData)
    sectionContents.forEach((content) => {
      getContentLinkMatchResult(content).forEach(({ sectionId }) => {
        linkSectionIds.add(sectionId)
      })
    })
  })
  console.log('getLinkSectionIds linkSectionIds', linkSectionIds)
  return [...linkSectionIds]
}

export const processContentLink = (content = '', sectionIdMap) => {
  const matchResult = getContentLinkMatchResult(content)
  // console.log('matchResult', matchResult)

  matchResult.forEach(async ({
    sectionId, toReplaceLinkTitle, toReplaceLinkUrl, lang,
  }) => {
    const section = sectionIdMap[sectionId]
    if (section) {
      const {
        treeTitle, treeEnTitle, treeCnTitle, parentSectionId,
      } = section
      let title = treeTitle
      if (lang === 'en') title = treeEnTitle
      if (lang === 'cn') title = treeCnTitle
      // console.log({ content, title, toReplaceLinkTitle })

      let tagName = section.tag
      if (['appendices', 'appendix'].includes(section.sectionType)) {
        tagName = `tag/appendix/${getHashId(section.treeTitle)}`
      } else if (section.sectionType === 'info') {
        if (parentSectionId) {
          const parentSection = sectionIdMap.value[parentSectionId]
          tagName = `section/${getHashId(parentSection.treeTitle)}/${getHashId(section.treeTitle)}`
        } else {
          tagName = 'section'
        }
      } else if (section.sectionType === 'apis') {
        tagName = `tag/${section.tag}`
      } else if (section.sectionType === 'api') {
        tagName = `operation/${section.operationId}`
      }

      // #tag/appendix/8.3.-List-of-Currency-Types
      content = content.replaceAll(toReplaceLinkTitle, title).replaceAll(toReplaceLinkUrl, `#${tagName}`) // eslint-disable-line no-param-reassign
    }
  })
  return content
}

export const processContentBrand = (content, brandText) => {
  if (!content) return ''
  if (!brandText) return content
  return content.replaceAll('{{brand}}', brandText)
}

const processContent = (content, brandText, sectionIdMap) => processContentLink(processContentBrand(content, brandText), sectionIdMap)

export const renderTableDataHtml = ({
  tableData, platformsMap, brandText, sectionIdMap,
}) => {
  const { columns, rowData } = tableData

  let sortedColumnsIds = Object.keys(columns).sort((a, b) => columns[a].sortOrder - columns[b].sortOrder)

  const nonEmptyColumnsIds = rowData.reduce((acc, row) => {
    if (sortedColumnsIds[0] === 'platform' && !platformsMap[row.platform]) return acc
    if (sortedColumnsIds[0] === 'api' && !platformsMap[row.api]) return acc

    Object.keys(row).forEach((columnId) => {
      if (columnId !== 'rowId' && columnId !== 'sortOrder' && row[columnId]) acc.add(columnId)
    })
    return acc
  }, new Set())

  sortedColumnsIds = [...nonEmptyColumnsIds].sort((a, b) => columns[a].sortOrder - columns[b].sortOrder)

  const tableHeadHtml = `<thead><tr>${sortedColumnsIds.map(columnId => `<th>${columns[columnId].columnTitle.split('\n').map(line => line).join('<br>')}</th>`).join('')}</tr></thead>`
  const tableRowsHtml = rowData.reduce((acc, row) => {
    let trInnerHtml = ''
    if (sortedColumnsIds[0] === 'platform' && !platformsMap[row.platform]) return acc
    if (sortedColumnsIds[0] === 'api' && !platformsMap[row.api]) return acc

    trInnerHtml = sortedColumnsIds.map((columnId) => {
      let tdInnerHtml = typeof row[columnId] === 'string' ? processContent(row[columnId] || '', brandText, sectionIdMap) : row[columnId] || ''

      if (columnId === 'platform') {
        tdInnerHtml = platformsMap[row[columnId]] || row[columnId]
      } else if (Array.isArray(row[columnId])) {
        tdInnerHtml = row[columnId].map(cell => cell).join('<br>')
      } else if (typeof row[columnId] === 'object') {
        const getBooleanArrayText = (arr) => {
          if (arr.every(item => item === true)) return '<span class="nowrap">true 有</span>'
          if (arr.every(item => item === false)) return '<span class="nowrap">false 无</span>'
          return arr.map(item => `<span class="nowrap">${item} ${item ? '有' : '无'}</span>`).join('<br>')
        }
        const values = row.column_1.map(key => row[columnId][key]) // column_1: Game Type 游戏类型 = ['EGAME', 'SLOT']
        tdInnerHtml = getBooleanArrayText(values)
      } else if (columns[columnId].element === 'textarea') {
        tdInnerHtml = (tdInnerHtml || '').replaceAll('\n', '<br>')
      }

      return `<td>${tdInnerHtml}</td>`
    }).join('')

    acc += `<tr>${trInnerHtml}</tr>` // eslint-disable-line no-param-reassign
    return acc
  }, '')

  const tableHtml = `<table>${tableHeadHtml}${tableRowsHtml}</table>`
  return tableHtml
}

export const renderTableDataByPlatformHtml = ({
  tableData, platformsMap, brandText, sectionIdMap,
}) => {
  if (!tableData) return ''
  const { platformsOrder, platforms, rowData } = tableData
  if (rowData) {
    const tableHtml = renderTableDataHtml({
      tableData, platformsMap, brandText, sectionIdMap,
    })
    return tableHtml
  }

  return platformsOrder.reduce((acc, platform) => {
    if (!platformsMap[platform]) return acc
    const platformTableData = platforms[platform]
    acc += `<p><b>Platform:</b> ${platformsMap[platform]}</p>${renderTableDataHtml({ // eslint-disable-line no-param-reassign
      tableData: platformTableData, platformsMap, brandText, sectionIdMap,
    })}`
    return acc
  }, '')
}

export const renderStringifiedJsonTableRowArray = (fieldData, docData = {}) => {
  const { fieldsOrder } = fieldData
  if (!fieldsOrder?.length) return ''

  const arr = []
  fieldsOrder.forEach((childFieldId) => {
    if (!shouldDisplay(fieldData.fields[childFieldId] || {}, docData)) return

    const childFieldData = fieldData.fields[childFieldId]
    arr.push(childFieldData)
    if (childFieldData.fieldType === 'array of objects') arr.push(...renderStringifiedJsonTableRowArray(childFieldData, docData))
  })

  return arr
}

export const handleRestrictedSection = (section, docData = {}, onlyReturnChangedSection = false) => {
  const { platforms: docPlatforms = [], clients: docClients = [], excludedPlatforms: docExcludedPlatforms = [] } = docData
  if (!section.restricted) return onlyReturnChangedSection ? null : section

  const clonedSection = onlyReturnChangedSection ? cloneDeep(section) : section

  const { platforms: restrictedPlatforms = [], clients: restrictedClients = [] } = section.restricted || {}

  let sectionChanged = false
  let filteredRestrictedPlatforms = []
  let filteredRestrictedClients = []
  if (restrictedPlatforms?.length) {
    if (docPlatforms?.length) {
      filteredRestrictedPlatforms = restrictedPlatforms.filter(platform => docPlatforms.includes(platform))
      if (filteredRestrictedPlatforms.length && !isEqual(filteredRestrictedPlatforms, restrictedPlatforms)) {
        clonedSection.restricted.platforms = filteredRestrictedPlatforms
        sectionChanged = true
      }
    } else if (docExcludedPlatforms?.length) {
      filteredRestrictedPlatforms = restrictedPlatforms.filter(platform => !docExcludedPlatforms.includes(platform))
      if (filteredRestrictedPlatforms.length && !isEqual(filteredRestrictedPlatforms, restrictedPlatforms)) {
        clonedSection.restricted.platforms = filteredRestrictedPlatforms
        sectionChanged = true
      }
    }
  }

  if (restrictedClients?.length && docClients?.length) {
    filteredRestrictedClients = restrictedClients.filter(client => docClients.includes(client))
    if (filteredRestrictedClients.length && !isEqual(filteredRestrictedClients, restrictedClients)) {
      clonedSection.restricted.clients = filteredRestrictedClients
      sectionChanged = true
    }
  }
  console.log('handleRestrictedSection', { filteredRestrictedPlatforms, filteredRestrictedClients })
  if (!filteredRestrictedPlatforms.length && !filteredRestrictedClients.length) {
    sectionChanged = true
    delete clonedSection.restricted
  }
  return onlyReturnChangedSection ? sectionChanged ? clonedSection : null : clonedSection // eslint-disable-line no-nested-ternary
}
